module.exports = __webpack_public_path__ + "img/SD_Steel_Dagger_512.39de7633.png";